import { Badge } from "@/components/ui/badge";
import { Lock, Percent, Package, Layers } from "lucide-react";
import { CAMPAIGN_TYPES, type CampaignType } from "@/utils/campaign-types";

interface CampaignTypeBadgeProps {
  type: CampaignType;
  showIcon?: boolean;
}

const CAMPAIGN_TYPE_CONFIG: Record<CampaignType, {
  label: string;
  color: string;
  icon: any;
}> = {
  [CAMPAIGN_TYPES.PRO012]: {
    label: "Combo Legado",
    color: "bg-gray-100 text-gray-700 border-gray-300",
    icon: Lock,
  },
  [CAMPAIGN_TYPES.PRO013]: {
    label: "Leve X Pague Y",
    color: "bg-purple-100 text-purple-700 border-purple-300",
    icon: Percent,
  },
  [CAMPAIGN_TYPES.PRO014]: {
    label: "Promoção Itens",
    color: "bg-blue-100 text-blue-700 border-blue-300",
    icon: Package,
  },
  [CAMPAIGN_TYPES.PRO017]: {
    label: "Combo Moderno",
    color: "bg-green-100 text-green-700 border-green-300",
    icon: Layers,
  },
};

export function CampaignTypeBadge({ type, showIcon = true }: CampaignTypeBadgeProps) {
  const config = CAMPAIGN_TYPE_CONFIG[type] || CAMPAIGN_TYPE_CONFIG[CAMPAIGN_TYPES.PRO013];
  const Icon = config.icon;

  return (
    <Badge variant="outline" className={`${config.color} font-medium`}>
      {showIcon && <Icon className="w-3 h-3 mr-1" />}
      {config.label}
    </Badge>
  );
}
